class MultiColumnSlider {
  constructor(section) {
    this.section = section;
    this.track = section.querySelector('.multi-column-slider__track');
    this.slides = Array.from(section.querySelectorAll('.multi-column-slider__slide'));
    this.prevButton = section.querySelector('.multi-column-slider__arrow--prev');
    this.nextButton = section.querySelector('.multi-column-slider__arrow--next');
    this.dots = Array.from(section.querySelectorAll('.multi-column-slider__dot'));
    this.currentIndex = 0;
    this.timer = null;
    this.autoplay = section.dataset.autoplay === 'true';
    this.speed = parseInt(section.dataset.speed || '5000', 10);

    if (!this.track || this.slides.length <= 1) return;

    this.bindEvents();
    this.goTo(0, false);

    if (this.autoplay && !Shopify.designMode) {
      this.startAutoplay();
    }
  }

  bindEvents() {
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => {
        this.prev();
        this.restartAutoplay();
      });
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => {
        this.next();
        this.restartAutoplay();
      });
    }

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.slideIndex, 10);
        this.goTo(index);
        this.restartAutoplay();
      });
    });
  }

  goTo(index, animate = true) {
    if (!this.track) return;

    if (index < 0) index = this.slides.length - 1;
    if (index >= this.slides.length) index = 0;

    this.currentIndex = index;

    this.track.style.transition = animate ? 'transform 0.5s ease' : 'none';
    this.track.style.transform = `translateX(-${index * 100}%)`;

    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
    });
  }

  next() {
    this.goTo(this.currentIndex + 1);
  }

  prev() {
    this.goTo(this.currentIndex - 1);
  }

  startAutoplay() {
    this.stopAutoplay();
    this.timer = setInterval(() => {
      this.next();
    }, this.speed);
  }

  stopAutoplay() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  restartAutoplay() {
    if (this.autoplay && !Shopify.designMode) {
      this.startAutoplay();
    }
  }

  pause() {
    this.stopAutoplay();
  }

  resume() {
    if (this.autoplay && !Shopify.designMode) {
      this.startAutoplay();
    }
  }

  destroy() {
    this.stopAutoplay();
  }
}

function initMultiColumnSliders(container = document) {
  const sliders = container.querySelectorAll('.multi-column-slider');
  sliders.forEach((slider) => {
    if (!slider.sliderInstance) {
      slider.sliderInstance = new MultiColumnSlider(slider);
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initMultiColumnSliders(document);
});

document.addEventListener('shopify:section:load', function (event) {
  initMultiColumnSliders(event.target);
});

document.addEventListener('shopify:section:unload', function (event) {
  const sliders = event.target.querySelectorAll('.multi-column-slider');
  sliders.forEach((slider) => {
    if (slider.sliderInstance) {
      slider.sliderInstance.destroy();
      slider.sliderInstance = null;
    }
  });
});

document.addEventListener('shopify:block:select', function (event) {
  const slide = event.target.closest('.multi-column-slider__slide');
  if (!slide) return;

  const slider = slide.closest('.multi-column-slider');
  if (!slider || !slider.sliderInstance) return;

  const slides = Array.from(slider.querySelectorAll('.multi-column-slider__slide'));
  const index = slides.indexOf(slide);

  if (index >= 0) {
    slider.sliderInstance.goTo(index);
    slider.sliderInstance.pause();
  }
});

document.addEventListener('shopify:block:deselect', function (event) {
  const slide = event.target.closest('.multi-column-slider__slide');
  if (!slide) return;

  const slider = slide.closest('.multi-column-slider');
  if (!slider || !slider.sliderInstance) return;

  slider.sliderInstance.resume();
});